/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type KustomerTokenQueryVariables = Types.Exact<{ [key: string]: never }>;

export type KustomerTokenQuery = {
  readonly __typename?: 'Query';
  readonly kustomerToken: {
    readonly __typename?: 'Kustomer';
    readonly token: string;
  } | null;
};

export const KustomerTokenDocument = gql`
  query KustomerToken {
    kustomerToken {
      token
    }
  }
`;

export function useKustomerTokenQuery(
  options?: Omit<Urql.UseQueryArgs<KustomerTokenQueryVariables>, 'query'>,
) {
  return Urql.useQuery<KustomerTokenQuery, KustomerTokenQueryVariables>({
    query: KustomerTokenDocument,
    ...options,
  });
}
